/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { TopCustomersByPriorityDto } from '../dto';

export const TopCustomersByPriorityMapper = entity<TopCustomersByPriorityDto>({});
